import React from 'react';
import {ASH, CHARCOAL, FOCUS_BLUE, WHITE} from '../../../shared/style/colors';
import {BASE_TEXT, WEIGHT} from '../../../shared/style/typography';
import glamorous from 'glamorous';
import {PHONE} from '../../../shared/style/breakpoints';
import PropTypes from 'prop-types';
import {LIGHT_BLUE} from '../../../shared/library/notices/themes';
import {useSendAnalyticsEvent} from '../../../shared/enhancers/analytics-enhancer';
import {redirectTo} from '../../../shared/utils/navigation';
import GhostButton from '../../../shared/library/buttons/base/ghost';

const Container = glamorous.div({
  height: 95,
  display: 'flex',
  background: WHITE,
  border: `1px solid ${ASH}`,
  borderRadius: 4,
  marginBottom: 22,
  paddingLeft: 30,
  paddingRight: 30,
  alignItems: 'center',
  [PHONE]: {
    height: 80,
    background: LIGHT_BLUE,
    border: 0,
    borderRadius: 0,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 10
  }
});

const Text = glamorous.div({
  ...BASE_TEXT,
  fontSize: 16,
  lineHeight: 1.53,
  color: CHARCOAL,
  marginRight: 25,
  '>strong': {
    fontWeight: WEIGHT.BOLD,
    color: FOCUS_BLUE
  },
  '>strong a': {
    fontWeight: WEIGHT.BOLD,
    color: FOCUS_BLUE
  },
  flexGrow: 1,
  [PHONE]: {
    fontSize: 12,
    marginLeft: 10,
    marginRight: 10
  }
});

const Claim = ({children, buttonText, companySlug}) => {
  const sendAnalyticsEvent = useSendAnalyticsEvent();

  return (
    <Container>
      <Text>{children}</Text>
      {buttonText && (
        <GhostButton
          color={FOCUS_BLUE}
          onClick={() => {
            sendAnalyticsEvent('click_claimCTA');
            redirectTo(`become-company-member?company=${companySlug}`);
          }}
        >
          {buttonText}
        </GhostButton>
      )}
    </Container>
  );
};

Claim.propTypes = {
  children: PropTypes.any,
  buttonText: PropTypes.string,
  companySlug: PropTypes.string
};

export default Claim;
